export default function ContractRP({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker 舊生續購優惠方案</div>

      <div className="card w-75 p-5 m-auto">
        <ol class="contract-list">
          <li>
            購買方案者，須填妥本訂購單資料表，完整審閱並同意本購買須知與相關規定後，完成付費，方符合訂購程序。
            繳費前，請務必再次確認所購買之產品內容與費用。
          </li>

          <li>
            購買前請確認已完整審閱本購買須知與相關規定，並確認審閱期已達五日。
            本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第2條所定，
            得排除消費者保護法第19條七日解除權之合理例外情事。
            惟若商品未經領取、未開始參加任何課程，且未登入任何產品內含之學習帳號者，
            於購買後七日猶豫期內仍得要求退費；
            若已取得諮詢服務者，退費時需扣除每階段新台幣 3,000 元之諮詢費用。
          </li>
          <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容，並同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
          <li>
            教材一經領取或學習帳號一經登入後，恕不退費，亦不得要求暫停或延後使用效期。
          </li>

          <li>
            學員於領取帳號後，應妥善保管其登入帳號與密碼，並確保不為第三人知悉。
            任何利用該帳號密碼登入學習系統之行為，均推定為學員本人之行為。
            若因非可歸責於 Becker Taiwan（捷進）之事由導致帳號或密碼外洩，
            學員應立即通知 Becker Taiwan（捷進），
            Becker Taiwan（捷進）僅提供必要協助，並不負任何法律責任。
          </li>

          <li>
            購買方案者應保證其為完全行為能力人；
            如為限制行為能力人，則應已取得其法定代理人之同意。
          </li>

          <li>
            使用本服務，學員應自行具備以下軟硬體設備與連線環境：
            <ul>
              <li>
                系統需求：
                <ul>
                  <li>Windows 桌上型或筆記型電腦：Windows 7（含）以上</li>
                  <li>Apple 桌上型或筆記型電腦：macOS 10（含）以上</li>
                  <li>Apple 行動裝置：iOS 13.0（含）以上</li>
                  <li>Android 行動裝置：Android 8.0（含）以上</li>
                  <li>※ 行動裝置僅限使用官方 APP 觀看課程</li>
                </ul>
              </li>
              <li>
                連線需求：
                <ul>
                  <li>寬頻網路下載速度須達 20Mbps 以上</li>
                  <li>不建議使用無線、社區型、有線電視台網路或公共免費網路，
                      以免影響登入驗證或造成帳號資料外洩</li>
                  <li>※ 行動裝置僅限使用官方 APP 觀看課程</li>
                  <li>※ 其餘未列示之設備或系統，恕不保證其觀看品質</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            學員所填寫之 E-mail 信箱有效期限須達二十四個月以上，
            本軟體服務及所有相關通知將以該信箱作為主要聯繫方式。
            若因學員未定期收信而影響自身權益，概由學員自行負責。
          </li>

          <li>
            Becker CPA Exam Review 系列為美國進口原版教材與軟體，
            方案內含之教材、課程及諮詢服務，均僅限購買者本人使用。
            嚴禁任何形式之轉售、轉贈、轉讓、出租或分享，
            若經查證屬實，學員應賠償購買總價十倍之懲罰性違約金，
            並負相關損害賠償責任。
          </li>

          <li>
            以舊生續購之 Becker CPA Exam Review 與 Becker CPA Exam Final Review，
            其使用權限效期自購買日起算二十四個月後終止
            （Your Becker CPA Exam Review license will expire 24 months from the date of purchase）。
          </li>

          <li>
            自 2025 年 1 月 1 日起，所有方案僅提供電子教科書，不包含紙本教科書。
            若因個人需求需加購紙本教科書者，須依美國 Becker 原廠定價，
            另加計國際運費後購買。
          </li>

          <li>
            所有方案內含之教材、課程、服務與相關內容，
            均須於使用效期內完成領取與使用，逾期視同放棄，不得異議。
          </li>

          <li>
            為提升服務品質並確保學員正確使用教材，
            Becker Professional Education 與 Becker Taiwan（捷進）
            將蒐集、處理並分析帳號之登入時間、網路位址（IP Address）等相關資訊。
            若系統偵測多人共用同一帳號之情形，
            Becker Taiwan（捷進）得立即中止該帳號之使用權限。
          </li>

          <li>
            學員如有違反法律強制規定、公序良俗，
            或違反本合約內容經通知限期改正仍未改善者，
            Becker Taiwan（捷進）得終止本合約，學員不得異議。
            學員自行終止或因可歸責於學員之事由終止合約者，
            教材一經領取或帳號登入後，恕不退費。
          </li>

          <li>
            購買含持續展延（Unlimited Access）資格之方案者，
            於每次使用效期屆滿前三十日內，
            檢附學員本人即將赴考之考場預約證明，
            經審核通過後，得免費展延軟體效期六個月。
            未於期限內提出申請並通過審核者，
            即喪失該次展延與後續申請資格。
          </li>

          <li>
            Becker Taiwan（捷進）所提供之考程顧問諮詢服務，
            僅限購買者本人使用，並以協助完成報考流程為目的，
            不構成任何考試資格或結果之保證。
          </li>

          <li>
            學分評估結果僅供參考，
            實際是否符合報考資格，
            仍應以考試指定之認證機構與官方審查結果為準。
          </li>

          <li>
            Becker Taiwan（捷進）保留因原廠停產、
            或原廠變更產品規格而調整供貨內容之權利，
            並對此不負任何賠償責任。
          </li>

          <li>
            Becker Taiwan（捷進）已依法完成補習班立案登記，
            並加入補教品保協會辦理之補習服務聯合連帶保證協定。
            學員個人資料之蒐集、處理與利用，
            均依個人資料保護法相關規定辦理。
          </li>

        </ol>


          <div className="text-center mt-4">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>
              下一步
            </div>
          </div>
        </div>
      </div>
  );
}
